
<div class="row comment comment-level-{{level}}">
  <div class="col-sm-1">
      <img
        *ngIf="comment.user.profileImageUrl"
        class="comment-user-avatar"
        [ngClass]="{'user--blocked': isCommentUserBlocked && isUserCommentsAdmin}"
        [ngbTooltip]="'To unblock this user go to the stream page.'"
        [disableTooltip]="!isCommentUserBlocked"
        [ngClass]="{'user--blocked': isCommentUserBlocked && isUserCommentsAdmin}"
        [src]="comment.user.profileImageUrl + '?u=' + comment.user['updated']"
        [alt]="comment?.user?.displayName" />
      <span
        *ngIf="!comment.user.profileImageUrl"
        placement="top"
        [ngbTooltip]="'To unblock this user go to the stream page.'"
        [disableTooltip]="!isCommentUserBlocked"
        [ngClass]="{'user--blocked': isCommentUserBlocked && isUserCommentsAdmin}"
        class="comment-user-avatar">
        <svg enable-background="new 0 0 32 32" id="Stock_cut" version="1.1" viewBox="0 0 32 32" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><desc/><g><circle cx="16" cy="16" fill="none" r="15" stroke="#000000" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/><path d="M26,27L26,27   c0-5.523-4.477-10-10-10h0c-5.523,0-10,4.477-10,10v0" fill="none" stroke="#000000" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/><circle cx="16" cy="11" fill="none" r="6" stroke="#000000" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/></g></svg>
      </span>
  </div>
  <div class="col-sm-11">
    <div class="comment-info-container">
      <div class="row">
        <div class="col-sm-12">
          <a class="comment-author" [routerLink]="['/user',comment.user.id, 'profile']">{{comment?.user?.displayName}}</a>
          <span class="comment-created-time">{{comment?.created | timeAgo}}</span>
          <div ngbDropdown class="action-menu" *ngIf="isCommentFromCurrentUser">
            <fa-icon class="action-dots" [icon]="['fas', 'ellipsis-v']" ngbDropdownToggle></fa-icon>
            <div ngbDropdownMenu>
              <button class="dropdown-item" (click)="editComment()">Edit this comment</button>
              <button class="dropdown-item" (click)="deleteComment()">Delete this comment</button>
            </div>
          </div>
          <div ngbDropdown class="action-menu" *ngIf="isUserCommentsAdmin && !isCommentFromCurrentUser">
            <fa-icon class="action-dots" [icon]="['fas', 'ellipsis-v']" ngbDropdownToggle></fa-icon>
            <div ngbDropdownMenu>
              <button
                *ngIf="!isCommentUserBlocked"
                class="dropdown-item"
                (click)="blockCommentOwner()">Block this user comments</button>
              <button class="dropdown-item" (click)="deleteUserComment()">Delete comment</button>
            </div>
          </div>
          <p *ngIf="!editMode" class="comment-text">{{comment?.comments}}</p>
          <div *ngIf="editMode" class="edit-comment">
            <textarea class="form-control" placeholder="Add Reply" rows="3" [(ngModel)]="editedContent"></textarea>
            <button (click)="saveEditedComment()" class="notd__button--v2 button--black">Save</button>
            <button (click)="stopEditing()" class="notd__button--v2 button--black">Cancel</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <span class="comment-action" (click)="likeComment()" *ngIf="!isCommentFromCurrentUser">Like</span>
          <span class="comment-action" (click)="dislikeComment()" *ngIf="!isCommentFromCurrentUser">DisLike</span>
          <span class="comment-action" (click)="replyCollapsed = !replyCollapsed">Reply</span>
          <span class="comment-action text-danger" (click)="openReportCommentModal(comment.postId, comment.id)" i18n="@@PROFILE-COMMENT-002">Report</span>
          <fa-icon *ngIf="comment.likes && comment.likes > 0" [icon]="['far', 'thumbs-up']">
            <span [innerHTML]="'('+comment.likes+')'"></span>
          </fa-icon>
          <fa-icon *ngIf="comment.dislikes && comment.dislikes > 0" [icon]="['far', 'thumbs-down']">
            <span [innerHTML]="'('+comment.dislikes+')'"></span>
          </fa-icon>
        </div>
      </div>
      <div class="row" [ngbCollapse]="!replyCollapsed">
        <div class="col-sm-12">
          <textarea class="form-control" placeholder="Add Reply" rows="3" [(ngModel)]="newReply"></textarea>
          <button (click)="addReply()" [disabled]="!newReply || newReply.length < 4" class="btn notd-secondary-btn">Add Reply</button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-comment *ngFor="let reply of comment.replies" (refreshComments)="refreshComments.emit(true)" [comment]="reply" [level]="getNextLevel()"></app-comment>

<ng-template #blockUserModal let-c="close" let-d="dismiss">
  <a (click)="d('Cross click')" data-cy="close-modal" class="block-user-modal__close-btn" title="Close Modal">
      <svg enable-background="new 0 0 413.348 413.348" height="512" viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/></svg>
  </a>
  <h2 class="block-user-modal__title">Block owner of this comment</h2>
  <section class="block-user-modal__content">
    <div class="block-user-modal__content__text">
      Before blocking this user please add some comment.
    </div>
    <div
      class="block-user-modal__content__info">
      <svg data-name="Layer 1" id="Layer_1" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><defs><style>.cls-1{fill:#7dccfc;}</style></defs><path class="cls-1" d="M16,1A15,15,0,1,0,31,16,15,15,0,0,0,16,1Zm2,22a2,2,0,0,1-4,0V16a2,2,0,0,1,4,0ZM16,12.19A2.19,2.19,0,1,1,18.19,10,2.19,2.19,0,0,1,16,12.19Z"/></svg>
      <p>After blocking the user will not be allowed to add comments on this stream and all his comments will be deleted.</p>
    </div>
    <form
        class="block-user-modal__content__form" [formGroup]="blockUserForm">
        <textarea
          class="block-user-modal__content__form__input-wrapper__textarea notd__textarea"
          formControlName="comment"
          placeholder="Please add some comment"></textarea>
        <span
          class="block-user-modal__content__form__input-wrapper__error"
          *ngIf="blockUserForm.get('comment').touched && blockUserForm.get('comment').invalid">
          <svg enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="256" x2="256" y1="512" y2="0"><stop offset="0" stop-color="#fd3a84"/><stop offset="1" stop-color="#ffa68d"/></linearGradient><linearGradient id="lg1"><stop offset="0" stop-color="#ffc2cc"/><stop offset="1" stop-color="#fff2f4"/></linearGradient><linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="256" x2="256" xlink:href="#lg1" y1="301" y2="91"/><linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="256" x2="256" xlink:href="#lg1" y1="421" y2="331"/><g><g><path d="m355.826 512h-199.651c-3.979 0-7.794-1.58-10.606-4.394l-141.175-141.174c-2.814-2.813-4.394-6.628-4.394-10.606v-199.652c0-3.978 1.58-7.793 4.394-10.606l141.174-141.174c2.813-2.814 6.628-4.394 10.607-4.394h199.651c3.979 0 7.794 1.581 10.606 4.394l141.174 141.174c2.813 2.813 4.394 6.628 4.394 10.606v199.651c0 3.978-1.58 7.793-4.394 10.606l-141.173 141.175c-2.813 2.813-6.628 4.394-10.607 4.394z" fill="url(#SVGID_1_)"/></g><g id="Error"><g><path d="m256 301c-24.813 0-45-20.187-45-45v-120c0-24.813 20.187-45 45-45s45 20.187 45 45v120c0 24.813-20.187 45-45 45z" fill="url(#SVGID_2_)"/></g><g><path d="m256 421c-24.813 0-45-20.187-45-45s20.187-45 45-45 45 20.187 45 45-20.187 45-45 45z" fill="url(#SVGID_3_)"/></g></g></g></svg>
          Please set your comment.
        </span>
    </form>
    <div class="block-user-modal__content__buttons">
        <button
            type="button"
            [disabled]="blockUserForm.invalid" class="notd__button--v2 button--black" (click)="d('Cross click'); confirmUserBlocking();">Block user</button>
        <button
            type="button"
            class="notd__button--v2 button--black" (click)="d('Cross click');">Close</button>
    </div>
  </section>
</ng-template>